module.exports = __webpack_public_path__ + "kraftmaid.svg?a3d3379c4449fc4bc3e1a8017aa1e6b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kraftmaid.svg
// module id = 625
// module chunks = 0